// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__28AVI","tab":"Tabs_tab__DQqx6","tabActive":"Tabs_tabActive__U2Aba"};